import {
  defaultFilters,
  SearchFilters,
  SearchFilterKeys,
} from '@cinch-nx/data-search'

const arraysContainsEqualValues = <T>(a: T[], b: T[]) => {
  if (a.length !== b.length) {
    return false
  }
  return (
    a.every((item) => b.includes(item)) && b.every((item) => a.includes(item))
  )
}

export const getActiveFilters = (filters: SearchFilters) =>
  Object.entries(filters).reduce<Array<SearchFilterKeys>>(
    (activeFilters, [key, value]) => {
      const filtersKey = key as SearchFilterKeys
      if (!arraysContainsEqualValues(defaultFilters[filtersKey], value)) {
        activeFilters.push(filtersKey)
      }
      return activeFilters
    },
    [],
  )
